<app-search-field [form]="form" placeholder="職員検索"></app-search-field>
<ng-container *ngIf="filtered$ | async as staffList">
  <ul *ngIf="staffList.length > 0; else none" class="staff-list">
    <li *ngFor="let staff of staffList">
      <app-staff-item
        [staff]="staff"
        (click)="onChange(staff)"
      ></app-staff-item>
    </li>
  </ul>
  <ng-template #none>
    <p class="list-none">表示するデータがありません</p>
  </ng-template>
</ng-container>
